// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import '@mdi/font/css/materialdesignicons.css'
import '@/styles/index.scss' //全局样式
import store from './store' //store vuex
import '@/permission' // 路由守护
import htmlToExcel from './plugins/htmlToExcel' //excel
import { getUrl,setUrl } from '@/utils/baseurl'


import { DatePicker,Dialog,Upload,Select,DropdownMenu,
  Menu,MenuItem,Submenu, DropdownItem , Dropdown,
  Option,Image,Checkbox,CheckboxGroup, Cascader,Button,
  InputNumber,Input,Form,FormItem, Table,TableColumn,
  Pagination,Steps,Step,Drawer,Descriptions,DescriptionsItem
} from 'element-ui';

Vue.prototype.htmlToExcels = htmlToExcel
Vue.config.productionTip = false
if (getUrl() == null){
  setUrl(process.env.EXTERNAL_URL)
}

Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Image)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Cascader)
Vue.use(Button)
Vue.use(InputNumber)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Drawer)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)

import Toast from '@/components/Toast/index.js'
Vue.use(Toast)

import ConfirmDialog from '@/components/ConfirmDialog/index.js'
Vue.use(ConfirmDialog)

import globalMethods from './utils/globalMethods';
Vue.use(globalMethods)
import VueI18n from 'vue-i18n'
// 创建i18n实例
Vue.use(VueI18n)
// 定义翻译的内容
import zh from './lang/zh'
import en from './lang/en'
import th from './lang/th'

// 创建i18n实例并传入选项
const i18n = new VueI18n({
  locale: localStorage.getItem('lang')?localStorage.getItem('lang'):'zh', // 默认语言
  fallbackLocale: 'en',
  messages: {
    zh,
    en,
    th,
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js